// Evidence partner list, extracted from src/api/scribeAPIV2.ts.
// History: git log --follow src/api/scribeAPIV2.ts.
import { getScribeHttpClients } from '@heidi/api/client';
import type { components } from '@heidi/schema/ml-scribe';

/** @domain evidence */
export const getEvidenceIntegrations = () => {
  return getScribeHttpClients().scribeHttpV2.get<
    components['schemas']['IntegrationsListResponse']
  >('/evidence/integrations', { params: { publisher_web_search: true } });
};
